import React, { useEffect } from "react";
import { CustomTable } from "../../component/common/customTable/CustomTable";
import { CircularProgress, Container, Stack, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { JobGetByVendorAsync } from "../../services/services";
import { asyncStatus } from "../../utils/asyncStatus";
import { themeOrange } from "../../utils/colorTheme";
import css from "./VendorDashboard.module.css";
import CurrentVendorJobsTab from "../../component/VendorJobsTabs/CurrentVendorJobsTab/CurrentVendorJobsTab";
import CustomTabs from "../../component/common/CustomTabs/CustomTabs";
import CompletedVendorJobsTab from "../../component/VendorJobsTabs/CompletedVendorJobsTab/CompletedVendorJobsTab";

const JobDone = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const defaultTab = tabParam === "completed" ? 1 : 0;

  const {
    get_job_by_vendor_status,
    get_job_by_vendor_data,
    get_job_by_vendor_error,
  } = useSelector((state) => state.serviceManage);

  const jobDoneLoader = get_job_by_vendor_status === asyncStatus.LOADING;

  const tabs = [
    {
      label: "Current Jobs",
      content: <CurrentVendorJobsTab />,
    },
    {
      label: "Completed Jobs",
      content: <CompletedVendorJobsTab />,
    },
  ];

  useEffect(() => {
    dispatch(JobGetByVendorAsync());
  }, []);

  return (
    <Container maxWidth="xl">
      <Stack gap={3}>
        <Stack>
          <Typography variant="caption" className={css.total}>
            Job{" "}
            <Typography variant="caption" className={css.main_heading}>
              Done
            </Typography>
          </Typography>
          <hr color={"#D1D1D1"} />
        </Stack>
        {jobDoneLoader ? (
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"center"}
            sx={{ height: "60vh", width: "100%" }}
          >
            <CircularProgress size={30} sx={{ color: themeOrange }} />
          </Stack>
        ) : !get_job_by_vendor_data?.length &&
          get_job_by_vendor_data?.length === 0 ? (
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"center"}
            sx={{ height: "60vh", width: "100%" }}
          >
            <Typography>No Jobs Found</Typography>
          </Stack>
        ) : (
          <CustomTabs tabs={tabs} defaultTab={defaultTab} />
        )}
      </Stack>
    </Container>
  );
};

export default JobDone;
